import React from "react";
import DashboardIcon from "@mui/icons-material/GridView";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/CategoryOutlined";
import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import SellIcon from "@mui/icons-material/SellOutlined";
import WarehouseIcon from "@mui/icons-material/WarehouseOutlined";
import InsightsIcon from "@mui/icons-material/InsightsOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";

export interface NavItem { label: string; path: string; icon: React.ReactElement; }

export const DISTRIBUTOR_NAV: NavItem[] = [
  { label: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
  { label: "Products", path: "/d/products", icon: <Inventory2Icon /> },
  { label: "Categories", path: "/d/categories", icon: <CategoryIcon /> },
  { label: "Customers", path: "/d/customers", icon: <PeopleIcon /> },
  { label: "Orders", path: "/d/orders", icon: <ReceiptLongIcon /> },
  { label: "Pricing", path: "/d/pricing", icon: <SellIcon /> },
  { label: "Inventory", path: "/d/inventory", icon: <WarehouseIcon /> },
  { label: "Reports", path: "/d/reports", icon: <InsightsIcon /> },
  { label: "Settings", path: "/d/settings", icon: <SettingsIcon /> },
];
